import { STATES } from "../data/states";
import { useGlobalModal } from "../context/ModalContext";
import { useState } from "react";
import emailjs from "emailjs-com";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const ModalFormulario = () => {

    const { closeModal, onConfirm, typeDemo } = useGlobalModal();
    const [formData, setFormData] = useState({
        nombre: '',
        apellido: '',
        telefono: '',
        email: '',
        estado: ''
    })
    const [telPrefijo, setTelPrefijo] = useState("0414");

    const webDemos = [
        "Innova Food & Drinks",
        "Innova Barber Shop",
        "Innova Service",
        "Innova Car Wash"
    ];

    const isWebDemo = webDemos.includes(typeDemo)
    const modalTitle = isWebDemo ? "Acceder a la Demo" : "Descargar el Demo";
    const modalDescription = isWebDemo
        ? "Por favor, ingrese sus datos para poder acceder a la demo."
        : "Por favor, ingrese sus datos para poder descargar el contenido.";
    const submitButtonText = isWebDemo ? "Enviar y acceder" : "Enviar y descargar";

    const handleSubmit = async (e) => {
        e.preventDefault();

        const fieldsEmpty = Object.values(formData).some(value => typeof value === 'string' ? value.trim() === '' : !value);

        if (fieldsEmpty) {
            withReactContent(Swal).fire({
                position: "top-end",
                title: "Por favor, completa todos los campos del formulario.",
                showConfirmButton: false,
                timer: 2000,
            });
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isEmailValid = formData.email !== "" && emailRegex.test(formData.email);

        if (!isEmailValid) {
            withReactContent(Swal).fire({
                position: "top-end",
                title: "Ingrese un correo electrónico válido.",
                showConfirmButton: false,
                timer: 2000,
            });
            return;
        }

        if (formData.telefono.length !== 7) {
            withReactContent(Swal).fire({
                position: "top-end",
                title: "El teléfono debe tener 7 dígitos.",
                showConfirmButton: false,
                timer: 2000,
            });
            return;
        }

        const templateParams = {
            demo_type: typeDemo || "Demo no especificada",
            full_name: `${formData.nombre} ${formData.apellido}`.trim(),
            telefono: `${telPrefijo}-${formData.telefono}`,
            email: formData.email,
            estado: formData.estado,
        };

        emailjs
            .send(
                "service_v0kt4ux",
                "template_mz22f3r",
                templateParams,
                "OeSqh-PhNkfeLu0u7"
            )
            .then((response) => {
                closeModal();
                withReactContent(Swal).fire({
                    position: "top-end",
                    title: "Correo enviado exitosamente.",
                    showConfirmButton: false,
                    timer: 1450,
                });
               
                setTimeout(() => {
                    if (onConfirm) onConfirm();
                }, 1500);

            })
            .catch((error) => {
                console.error("Error al enviar el correo:", error);
                withReactContent(Swal).fire({
                    position: "top-end",
                    title: "Error al enviar el correo.",
                    showConfirmButton: false,
                    timer: 100000,
                });
            });
    }
    
    const handleClose = () => {
        closeModal();
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const handleTelefonoChange = (e) => {
        const value = e.target.value.replace(/\D/g, "");
        if (value.length <= 7) {
            setFormData(prev => ({
                ...prev,
                telefono: value
            }));
        }
    }

    const handleEmailValidation = (e) => {
        const value = e.target.value;
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (value.length <= 64) {
            setFormData(prev => ({
                ...prev,
                email: value
            }));
        } else if (value === "" || (regex.test(value) && value.length >= 5 && value.length <= 64)) {
            setFormData(prev => ({
                ...prev,
                email: value
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                email: value.slice(0, 64)
            }));
        }
    }

    const handleTextValidation = (e) => {
        const { name, value } = e.target;
        const regex = /^[a-zA-ZáéíóúÁÉÍÓÚüÜñÑ\s]*$/;
        if (regex.test(value) && value.length <= 50) {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    }

    return (
        <div className="modal-wrapper" onClick={handleClose}>
            <div className="modal-content relative bg-white rounded-[28px] shadow-2xl border border-gray-100 px-5 py-6 sm:px-6 sm:py-7" onClick={(e) => e.stopPropagation()}>
                <button className="absolute -top-4 right-3 bg-white rounded-full shadow-md w-9 h-9 flex items-center justify-center hover:scale-105 transition" onClick={handleClose}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"><path d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z" fill="#000000" /><path d="M9.17011 15.58C8.98011 15.58 8.79011 15.51 8.64011 15.36C8.35011 15.07 8.35011 14.59 8.64011 14.3L14.3001 8.63999C14.5901 8.34999 15.0701 8.34999 15.3601 8.63999C15.6501 8.92999 15.6501 9.40998 15.3601 9.69998L9.70011 15.36C9.56011 15.51 9.36011 15.58 9.17011 15.58Z" fill="#000000" /><path d="M14.8301 15.58C14.6401 15.58 14.4501 15.51 14.3001 15.36L8.64011 9.69998C8.35011 9.40998 8.35011 8.92999 8.64011 8.63999C8.93011 8.34999 9.41011 8.34999 9.70011 8.63999L15.3601 14.3C15.6501 14.59 15.6501 15.07 15.3601 15.36C15.2101 15.51 15.0201 15.58 14.8301 15.58Z" fill="#000000" /></svg>
                </button>

                <form className="flex flex-col items-center justify-center gap-4" onSubmit={handleSubmit}>
                    <div className="w-full text-center mb-1">
                        <h3 className="text-xl sm:text-2xl font-bold text-gray-800">{modalTitle}</h3>
                        <p className="text-sm text-gray-500 mt-1">{modalDescription}</p>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-3 w-full" >
                        <input
                            type="text"
                            name="nombre"
                            id="nombre"
                            placeholder="Nombre"
                            className="h-12 px-4 border border-gray-300 rounded-xl outline-none focus:border-[#EF8318] transition"
                            value={formData.nombre}
                            onChange={handleTextValidation}
                            maxLength={50}
                            required
                        />
                        <input
                            type="text"
                            name="apellido"
                            id="apellido"
                            placeholder="Apellido"
                            className="h-12 px-4 border border-gray-300 rounded-xl outline-none focus:border-[#EF8318] transition"
                            value={formData.apellido}
                            onChange={handleTextValidation}
                            maxLength={50}
                            required
                        />
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-3 w-full" >
                        <div className="flex items-center gap-2 w-full">
                            <select
                                value={telPrefijo}
                                onChange={(e) => setTelPrefijo(e.target.value)}
                                className="h-12 px-3 border border-gray-300 rounded-xl outline-none focus:border-[#EF8318] transition bg-white"
                            >
                                <option value="0414">0414</option>
                                <option value="0424">0424</option>
                                <option value="0412">0412</option>
                                <option value="0422">0422</option>
                                <option value="0416">0416</option>
                                <option value="0426">0426</option>
                            </select>
                            <input
                                type="text"
                                name="telefono"
                                id="telefono"
                                placeholder="Teléfono"
                                className="h-12 px-4 border border-gray-300 rounded-xl w-full outline-none focus:border-[#EF8318] transition"
                                value={formData.telefono}
                                onChange={handleTelefonoChange}
                                required
                            />
                        </div>
                        <input
                            type="email"
                            name="email"
                            id="email"
                            placeholder="Email"
                            className="h-12 px-4 border border-gray-300 rounded-xl outline-none focus:border-[#EF8318] transition"
                            value={formData.email}
                            onChange={handleEmailValidation}
                            maxLength={64}
                            required
                        />
                    </div>

                    <select
                        id="estado"
                        name="estado"
                        value={formData.estado}
                        onChange={handleChange}
                        className="h-12 px-4 border border-gray-300 rounded-xl w-full outline-none focus:border-[#EF8318] transition bg-white text-gray-700"
                        required
                    >
                        <option value="">Selecciona tu estado</option>
                        {STATES.map((item) => (
                            <option key={item} value={item}>
                                {item}
                            </option>
                        ))}
                    </select>

                    <button
                        type="submit"
                        className="btnAdmin inline-flex items-center justify-center min-w-[220px] h-12 rounded-xl shadow-sm hover:scale-[1.02] transition"
                    >
                        {submitButtonText}
                    </button>
                </form>
            </div>
        </div>
    )
}

export default ModalFormulario